import React from "react";
import { formatDate } from "../../services/formateDate";

const BookingConfirmPage = ({
  data,
  closeModal,
  userDetails,
  setIsShareModalOpen,
}) => {
  return (
    <div className="booking-confirmaition-section" onClick={closeModal}>
      <div className="close-btn-wrapper-ticket">
        <div className="ticket-close-btn">
          <div className="close-btn-wrapper">
            <div
              className="close-btn-mob-search w-embed cursor-pointer"
              onClick={closeModal}
            >
              {/*?xml version="1.0" encoding="utf-8"?*/}
              <svg
                width="100%"
                height="100%"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 122.881 122.88"
                enableBackground="new 0 0 122.881 122.88"
                xmlSpace="preserve"
              >
                <g>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="white"
                    d="M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M81.719,36.226 c1.363-1.363,3.572-1.363,4.936,0c1.363,1.363,1.363,3.573,0,4.936L66.375,61.439l20.279,20.278c1.363,1.363,1.363,3.573,0,4.937 c-1.363,1.362-3.572,1.362-4.936,0L61.44,66.376L41.162,86.654c-1.362,1.362-3.573,1.362-4.936,0c-1.363-1.363-1.363-3.573,0-4.937 l20.278-20.278L36.226,41.162c-1.363-1.363-1.363-3.573,0-4.936c1.363-1.363,3.573-1.363,4.936,0L61.44,56.504L81.719,36.226 L81.719,36.226z"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="ticket-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="ticket-flex">
          <div className="ticket-left">
            <div className="section-home-header-ticket">
              <div className="page-padding">
                <div className="container-medium">
                  <div className="padding-vertical">
                    <div
                      data-w-id="12df7d36-bd31-47ca-0f72-005797c86a3b"
                      className="home-header_component"
                    >
                      <div className="header-content">
                        <div className="margin-bottom margin-small">
                          <h1 className="heading-ticket-title">
                            {data?.title}
                          </h1>
                        </div>
                        <div className="header-content_grid-ticket">
                          <div
                            id="w-node-_12df7d36-bd31-47ca-0f72-005797c86a41-9154355b"
                            className="header_grid-left-content-ticket"
                          >
                            <div className="review-block">
                              <div className="code-embed-date-icon w-embed">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  width={20}
                                  height={20}
                                  viewBox="0,0,256,256"
                                >
                                  <g
                                    fill="currentColor"
                                    fillRule="nonzero"
                                    stroke="none"
                                    strokeWidth={1}
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit={10}
                                    strokeDasharray=""
                                    strokeDashoffset={0}
                                    fontFamily="none"
                                    fontWeight="none"
                                    fontSize="none"
                                    textAnchor="none"
                                    style={{ mixBlendMode: "normal" }}
                                  >
                                    <g transform="scale(5.33333,5.33333)">
                                      <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <p className="location-name-on-listing text-align-left">
                                {formatDate(data?.event_date)}
                              </p>
                            </div>

                            <div className="superhost-block">
                              <div className="embed-code-location w-embed">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  width={20}
                                  height={20}
                                  viewBox="0,0,256,256"
                                >
                                  <g
                                    fill="currentColor"
                                    fillRule="nonzero"
                                    stroke="none"
                                    strokeWidth={1}
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit={10}
                                    strokeDasharray=""
                                    strokeDashoffset={0}
                                    fontFamily="none"
                                    fontWeight="none"
                                    fontSize="none"
                                    textAnchor="none"
                                    style={{ mixBlendMode: "normal" }}
                                  >
                                    <g transform="scale(5.33333,5.33333)">
                                      <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <p className="location-name-on-listing text-align-left mr-2">
                                {data?.address ? (
                                  <>
                                    {data?.address.length > 100
                                      ? `${data?.address.substring(0, 100)}...`
                                      : data?.address}
                                  </>
                                ) : (
                                  <>Bangalore</>
                                )}
                              </p>
                            </div>

                            <a
                              href="#"
                              className="country-block w-inline-block"
                            >
                              <div className="host-dp-lisiting-page">
                                <img
                                  loading="lazy"
                                  src={
                                    data?.creator_details?.photo
                                      ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${data?.creator_details?.photo}`
                                      : "../../static/media/user-icon-1.62f73db9586c0e3b573a.svg"
                                  }
                                  alt="Card preview"
                                  className="host-image-on-card"
                                />
                              </div>
                              <p className="host-name-lisiting-page text-align-left">
                                <p className="host-names text-black pt-2">
                                  {data?.creator_details?.first_name ||
                                    userDetails?.first_name}
                                </p>
                              </p>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="home-header_gridticket">
                        <div
                          id="w-node-_12df7d36-bd31-47ca-0f72-005797c86a60-9154355b"
                          className="header-image-block-ticket"
                        >
                          <img
                            alt=""
                            src={`https://high-table-2024.s3.ap-south-1.amazonaws.com/public/photo/tables/hd/${data?.media}`}
                            loading="lazy"
                            className="header-image-ticket"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ticket-right">
            <div className="ticket-right-top">
              <div className="tickmark-div">
                <div className="w-embed">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    fill="#fff"
                    y="0px"
                    width="100%"
                    height="100%"
                    viewBox="0 0 72 72"
                  >
                    <path d="M62.991,18.668c1.854,1.2,2.386,3.677,1.186,5.531l-4.642,7.173C59.829,32.872,60,34.415,60,36	c0,13.25-10.75,24-24,24S12,49.25,12,36s10.75-24,24-24c5.99,0,11.46,2.2,15.67,5.83L37.48,39.76l-8.15-9.33	c-1.09-1.25-2.98-1.38-4.23-0.29c-1.25,1.09-1.38,2.98-0.29,4.23l10.76,12.34c0.58,0.65,1.4,1.03,2.26,1.03	c0.08,0,0.15-0.01,0.22-0.01c0.94-0.07,1.79-0.57,2.3-1.36l17.11-26.516C58.66,17.998,61.135,17.467,62.991,18.668z" />
                  </svg>
                </div>
              </div>
              <h1 className="heading-ticket-right">Booking Confirmed!</h1>
            </div>
            <div className="bkccdiv">
              <div className="superhost-block-ticket">
                <p className="location-name-on-listing-ticket">
                  We’ll send you the location details the night before the table
                </p>
              </div>

              <a
                className="ticket-right-bottom w-inline-block cursor-pointer"
                onClick={() => setIsShareModalOpen(true)}
              >
                <p className="location-name-on-listing-ticket">
                  Invite a friend
                </p>
                <div className="div-block-130">
                  <div className="code-embed-10 w-embed">
                    <svg
                      fill="#ffffff"
                      viewBox="0 0 256 256"
                      id="Flat"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#ffffff"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <g id="SVGRepo_iconCarrier">
                        <g opacity="0.2">
                          <circle cx={128} cy={128} r={96} />
                        </g>
                        <g>
                          <path d="M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.09957,88.09957,0,0,1,128,216Z" />
                          <path d="M139.71582,88.40186a8,8,0,1,0-11.31348,11.314L148.68652,120H88a8,8,0,0,0,0,16h60.68652l-20.28418,20.28418a8,8,0,1,0,11.31348,11.314l33.94092-33.94091a8.00034,8.00034,0,0,0,0-11.31446Z" />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmPage;
